export default {
  retencao: []
}
